const MS_PER_DAY = 1000 * 60 * 60 * 24;

const toIso = (value) => {
  if (!value) return "";
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    const parsed = new Date(trimmed);
    if (!Number.isNaN(parsed.getTime())) {
      return toIso(parsed);
    }
  }
  return "";
};

/**
 * Calculează numărul de zile lucrătoare dintre două date (inclusiv),
 * excluzând orice dată prezentă în setul nonWorkingDates.
 *
 * @param {string|Date} startValue
 * @param {string|Date} endValue
 * @param {Object} options
 * @param {Set<string>} [options.nonWorkingDates] - Set cu valori ISO (YYYY-MM-DD) care reprezintă zile nelucrătoare.
 * @returns {number}
 */
export function computeWorkingDays(startValue, endValue, options = {}) {
  const { nonWorkingDates = new Set() } = options;
  if (!startValue || !endValue) return 0;

  const startDate = new Date(startValue);
  const endDate = new Date(endValue);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return 0;
  if (endDate < startDate) return 0;

  let total = Math.floor((endDate - startDate) / MS_PER_DAY) + 1;
  if (total <= 0) return 0;

  const cursor = new Date(startDate);
  while (cursor <= endDate) {
    const iso = toIso(cursor);
    if (iso && nonWorkingDates.has(iso)) {
      total -= 1;
    }
    cursor.setDate(cursor.getDate() + 1);
  }

  return total > 0 ? total : 0;
}

export function normalizeWorkingDate(value) {
  return toIso(value);
}
